import React from "react"

//Assets
import HeartIcon from "assets/img/icon/ico_heart-light.svg"
import imgProduct from "@public/img/sample/product.jpg"
import Cate1 from "@public/img/sample/cate1.png"
import Cate2 from "@public/img/sample/cate2.png"
import Cate3 from "@public/img/sample/cate3.png"
import Cate4 from "@public/img/sample/cate4.png"
import { Card, Image, Button, Link } from "components/anti"
import { useRouter } from "next/router"

const BlankState = ({ title, className, subtext, icon }) => {
  const { locale } = useRouter()
  const images = [Cate1, Cate2, Cate3, Cate4]

  return (
    <section className={`wishlist-blank ${className}`}>
      <div className="container mw-sm">
        <div className="top">
          <div className="wrapper-icon">
            <Image
              src={icon ?? HeartIcon}
              alt="heart"
              className="img-wishlist-top"
            />
          </div>
          <h3 className="title-content">{title ?? "No Wishlist Yet"}</h3>
          <h6 className="subtitle-content">
            {subtext
              ? subtext
              : locale === "id"
              ? "Periksa kategori ini untuk mulai membuat daftar keinginan Anda sendiri"
              : "Check these categories to start building your own wishlist"}
          </h6>
        </div>
        <Button variant="white" link="/" className="w-100 mt-4">
          {locale === "id" ? "Jelajahi Produk" : "Browse Products"}
        </Button>
        {/* <div className="row category-list">
          {images.map((el, i) => (
            <div className="col-md-3 col-6" key={i}>
              <Image src={el} alt={`category-${i + 1}`} ratio="r-4-5" />
            </div>
          ))}
        </div> */}
      </div>
    </section>
  )
}

export default BlankState
